import { useCallback } from 'react'
import useGetPreferredConsumerNetwork from '@/programmes/hooks/useGetPreferredConsumerNetwork'

const useIsPaymentEnabled = () => {
  const {
    getPreferredConsumerNetwork,
    loading,
  } = useGetPreferredConsumerNetwork()
  const getIsPaymentEnabled = useCallback(() => {
    const preferredConsumerNetwork = getPreferredConsumerNetwork()

    if (preferredConsumerNetwork?.name.toLowerCase() === 'sent with love') {
      return false
    }

    return true
  }, [getPreferredConsumerNetwork])

  return { getIsPaymentEnabled, loading }
}

export default useIsPaymentEnabled
